// export const ROLES = {
//   MANUAL_SWAP: "manual_swap",
//   ADMIN: "admin",

//   MANUAL_DIGITAL: "manual_swap.digital",
//   MANUAL_INVENTORY: "manual_swap.inventory",

//   CASH_COLLECTION: "cash_collection",
//   BATTERY_MOVEMENT: "battery_movement",
// };

export const ROLES_TYPE = {
  MANUAL_SWAP: "manual_swap",
  MANUAL_SWAP_DIGITAL: "digital_twin",
  MANUAL_SWAP_INVENTORY: "inventory",
  MANUAL_SWAP_OTA: "ota",
  CASH_COLLECTION: "cash_collection",
  BATTERY_MOVEMENT: "battery_movement",
};

export const ROLES = {
  MANUAL_SWAP: ROLES_TYPE.MANUAL_SWAP,
  ADMIN: "admin",

  MANUAL_DIGITAL: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_DIGITAL}`,
  MANUAL_INVENTORY: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_INVENTORY}`,
  MANUAL_OTA: `${ROLES_TYPE.MANUAL_SWAP}.${ROLES_TYPE.MANUAL_SWAP_OTA}`,

  CASH_COLLECTION: ROLES_TYPE.CASH_COLLECTION,
  BATTERY_MOVEMENT: ROLES_TYPE.BATTERY_MOVEMENT,
};

export const ROLE_HIERARCHY = {
  [ROLES.MANUAL_SWAP]: [ROLES.MANUAL_DIGITAL, ROLES.MANUAL_INVENTORY],
  [ROLES.ADMIN]: [
    ROLES.MANUAL_SWAP,
    ROLES.CASH_COLLECTION,
    ROLES.BATTERY_MOVEMENT,
  ],
};
